import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { emptyEvent, Event } from "../../../../interfaces/event";
import { deleteEvent, getEventSingle } from "../../../../services/event";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminEventDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function AdminEventDelete(props: AdminEventDeleteProps) {
    const [event, setEvent] = useState<Event>(emptyEvent);

    const handleDelete = () => {
        deleteEvent(props.id)
            .then(response => {
                if (response.data == 0) {
                    alert(t("Competition cannot be deleted. Try again later."));
                    props.onClose();
                } else {
                    props.onDelete(props.id);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getEventSingle(props.id)
            .then(response => {
                setEvent(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="admin-event-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("Delete event") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { event.id == 0 && 
                    <LoadingSpinner />
                }
                { event.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_event_message"
                                values={{
                                    event_name: event.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}